import { Icon } from '@eventbrite/eds-icon';
import { Lock } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { css, cx } from 'emotion';
import React from 'react';
import { CollectionEventCard } from '../types';

const LockIcon: React.FC = () => (
    <Icon
        size="xsmall"
        type={<Lock />}
        color="grey-800"
        strokeColor="grey-800"
    />
);

const PrivateCollectionMessage: React.FC = () => {
    return (
        <div className="eds-text-color--ui-800 eds-text-bs">
            {gettext('With restrictions')}
        </div>
    );
};

export const CollectionEventTitle: React.FC = ({ children }) => {
    return (
        <div>
            {children}
            <div className={cx('eds-l-pad-top-1', styles.flex)}>
                <div className={cx('eds-l-pad-right-1', styles.flex)}>
                    <LockIcon />
                </div>
                <div>
                    <PrivateCollectionMessage />
                </div>
            </div>
        </div>
    );
};

export const getEventTitleWrapper = (
    event: CollectionEventCard,
    launchPrivateCollections: boolean,
) => {
    return launchPrivateCollections && event?.isRestricted
        ? CollectionEventTitle
        : null;
};

const styles = {
    flex: css`
        display: flex;
    `,
};
